import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackAnalyticsEvent } from "../utils/analytics";

const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname.startsWith("/admin")) return;

    const sessionKey = "krrish_analytics_visit_recorded";
    if (window.sessionStorage.getItem(sessionKey)) return;

    trackAnalyticsEvent("visit").then((saved) => {
      if (saved) window.sessionStorage.setItem(sessionKey, "true");
    });
  }, [location.pathname]);

  return null;
};

export default AnalyticsTracker;
